import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { CrawlingLogs } from '../../models/crawling';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root'
})
export class GestioneCrawlingService {
  private readonly http = inject(HttpClient);
  private readonly commonService = inject(CommonService);

  downloadJSONorXML(fileName: string): Observable<any> {
    let params = new HttpParams().set('fileName', fileName);
    return this.http.get(`${environment.api.host_path}/crawling-log/download`, {params: params, responseType: 'blob'})
  }
  
  downloadUrlsTxt(id: string): Observable<any> {
    return this.http.get(`${environment.api.host_path}/job-schedule/${id}/export-urls`, {responseType: 'text'});
  }

  uploadCrawlingDocuments(formData: FormData) {
    return this.http.post(`${environment.api.host_path}/crawling/upload-document`, formData);
  }

  addNewJobSchedule(params:any){
    return this.http.post(`${environment.api.host_path}/job-schedule`, params);
  }

  editJobSchedule(params: any) {
    return this.http.put(`${environment.api.host_path}/job-schedule`, params);
  }
  //cancella una schedulazione dal job schedule
  deleteJobScheduleTrigger(id: number){
    return this.http.delete(`${environment.api.host_path}/job-schedule/trigger/${id}`);
  }

  getJobScheduleList(pageIndex: number, pageSize: number, sortBy: string, jobScheduleFilter: { search?: string, status?: any }): Observable<any> {
    let params = new HttpParams().set('pageIndex', pageIndex).set('pageSize', pageSize).set('sortBy', sortBy);
    
    if(jobScheduleFilter.status){
      params = params.set('status', jobScheduleFilter.status);
    }  
    if(jobScheduleFilter.search) {
        params = params.set('search', jobScheduleFilter.search);
      }
    return this.http.get<any>(`${environment.api.host_path}/job-schedule/list`, { params });
  }

  deleteJobSchedule(id: number){
    return this.http.delete(`${environment.api.host_path}/job-schedule/${id}`);
  }

  runJobSchedule(id: number){
    return this.http.get(`${environment.api.host_path}/job-schedule/run/${id}`);
  }

  stopJobSchedule(id: number){
    return this.http.get(`${environment.api.host_path}/job-schedule/stop/${id}`);
  }

  stopAllJObs(){
    return this.http.get(`${environment.api.host_path}/job-schedule/stop-all`);
  }

  getCrawlingLogFiles(pageIndex: number, pageSize: number, sortBy: string, uploadedFilesFilter: {search: string, endDate: string, startDate: string, requireJson: string}){
    let httpOptions = {
      params: new HttpParams()
      .set('pageIndex', pageIndex)
      .set('pageSize', pageSize)
      .set('sortBy', sortBy)
    };

    httpOptions.params = this.commonService.processParams(httpOptions.params, uploadedFilesFilter);

    return this.http.get<any>(`${environment.api.host_path}/crawling-log/listFiles`, httpOptions);
  }

  getCrawlingLog(params: any) {
    const httpOptions = {
      params: new HttpParams()
    };
    httpOptions.params = this.commonService.processParams(httpOptions.params, params);

    return this.http.get<CrawlingLogs>(`${environment.api.host_path}/k8s-log/logs`, httpOptions);
  }

  changeJobScheduleState(id: number): Observable<any> {
    return this.http.put(`${environment.api.host_path}/job-schedule/state/${id}`, {});
  }

  indexingSingleUrl(url: string){
    let params = new HttpParams().set('url', url);

    return this.http.get<any>(`${environment.api.host_path}/job-schedule/index-single-url`, { params });
  }

  getKenticoFiles(pageIndex: number, pageSize: number, sortBy: string, kenticoHistoryFilter: {documentId: string, endDate: string, startDate: string, status: string}){
    let httpOptions = {
      params: new HttpParams()
      .set('pageIndex', pageIndex)
      .set('pageSize', pageSize)
      .set('sortBy', sortBy)
    };

    httpOptions.params = this.commonService.processParams(httpOptions.params, kenticoHistoryFilter);

    return this.http.get<any>(`${environment.api.host_path}/kentico/list`, httpOptions);
  }

}
